import { render, staticRenderFns } from "./ModalContentTicketDelete.vue?vue&type=template&id=5d5efaeb&scoped=true&"
import script from "./ModalContentTicketDelete.vue?vue&type=script&lang=js&"
export * from "./ModalContentTicketDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentTicketDelete.vue?vue&type=style&index=0&id=5d5efaeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5efaeb",
  null
  
)

export default component.exports